import { Action } from 'redux';

export class PayloadAction implements Action {
  type: string;
  newState?: any;
}

/*
 * This payload state 'applicantInfo' is generated dynamically when the form and page are created
 * 
 * The only reason we need this reducer is to apply an entire saved 'applicantInfo' state from an existing application.
 * Since this is all abstract, we can't infer anything about the initial state other than it is an object
*/
const INITIAL_STATE: any = {};

export const INIT_PAYLOAD = 'INIT_PAYLOAD';
export const RESET_STATE = 'RESET_APPLICANT_INFO_STATE';
export const SAVE_APPLICANT_INFO = 'SAVE_APPLICANT_INFO';

export function loadExistingApplicantInfoIntoState(state: any): PayloadAction {
  return {
    type: SAVE_APPLICANT_INFO,
    newState: state
  };
}

export function applicantInfo(state: any = INITIAL_STATE, action: PayloadAction) {
  switch (action.type) {
    case SAVE_APPLICANT_INFO:
        return Object.assign({}, action.newState);
    case RESET_STATE:
        return INITIAL_STATE;
    case INIT_PAYLOAD:
    default:
        return state;
  }
}

